module.exports.AcademicCapIcon = require("./AcademicCapIcon.js")
module.exports.AdjustmentsIcon = require("./AdjustmentsIcon.js")
module.exports.AnnotationIcon = require("./AnnotationIcon.js")
module.exports.ArchiveIcon = require("./ArchiveIcon.js")
module.exports.ArrowCircleDownIcon = require("./ArrowCircleDownIcon.js")
module.exports.ArrowCircleLeftIcon = require("./ArrowCircleLeftIcon.js")
module.exports.ArrowCircleRightIcon = require("./ArrowCircleRightIcon.js")
module.exports.ArrowCircleUpIcon = require("./ArrowCircleUpIcon.js")
module.exports.ArrowDownIcon = require("./ArrowDownIcon.js")
module.exports.ArrowLeftIcon = require("./ArrowLeftIcon.js")
module.exports.ArrowNarrowDownIcon = require("./ArrowNarrowDownIcon.js")
module.exports.ArrowNarrowLeftIcon = require("./ArrowNarrowLeftIcon.js")
module.exports.ArrowNarrowRightIcon = require("./ArrowNarrowRightIcon.js")
module.exports.ArrowNarrowUpIcon = require("./ArrowNarrowUpIcon.js")
module.exports.ArrowRightIcon = require("./ArrowRightIcon.js")
module.exports.ArrowSmDownIcon = require("./ArrowSmDownIcon.js")
module.exports.ArrowSmLeftIcon = require("./ArrowSmLeftIcon.js")
module.exports.ArrowSmRightIcon = require("./ArrowSmRightIcon.js")
module.exports.ArrowSmUpIcon = require("./ArrowSmUpIcon.js")
module.exports.ArrowUpIcon = require("./ArrowUpIcon.js")
module.exports.ArrowsExpandIcon = require("./ArrowsExpandIcon.js")
module.exports.AtSymbolIcon = require("./AtSymbolIcon.js")
module.exports.BackspaceIcon = require("./BackspaceIcon.js")
module.exports.BadgeCheckIcon = require("./BadgeCheckIcon.js")
module.exports.BanIcon = require("./BanIcon.js")
module.exports.BeakerIcon = require("./BeakerIcon.js")
module.exports.BellIcon = require("./BellIcon.js")
module.exports.BookOpenIcon = require("./BookOpenIcon.js")
module.exports.BookmarkAltIcon = require("./BookmarkAltIcon.js")
module.exports.BookmarkIcon = require("./BookmarkIcon.js")
module.exports.BriefcaseIcon = require("./BriefcaseIcon.js")
module.exports.CakeIcon = require("./CakeIcon.js")
module.exports.CalculatorIcon = require("./CalculatorIcon.js")
module.exports.CalendarIcon = require("./CalendarIcon.js")
module.exports.CameraIcon = require("./CameraIcon.js")
module.exports.CashIcon = require("./CashIcon.js")
module.exports.ChartBarIcon = require("./ChartBarIcon.js")
module.exports.ChartPieIcon = require("./ChartPieIcon.js")
module.exports.ChartSquareBarIcon = require("./ChartSquareBarIcon.js")
module.exports.ChatAlt2Icon = require("./ChatAlt2Icon.js")
module.exports.ChatAltIcon = require("./ChatAltIcon.js")
module.exports.ChatIcon = require("./ChatIcon.js")
module.exports.CheckCircleIcon = require("./CheckCircleIcon.js")
module.exports.CheckIcon = require("./CheckIcon.js")
module.exports.ChevronDoubleDownIcon = require("./ChevronDoubleDownIcon.js")
module.exports.ChevronDoubleLeftIcon = require("./ChevronDoubleLeftIcon.js")
module.exports.ChevronDoubleRightIcon = require("./ChevronDoubleRightIcon.js")
module.exports.ChevronDoubleUpIcon = require("./ChevronDoubleUpIcon.js")
module.exports.ChevronDownIcon = require("./ChevronDownIcon.js")
module.exports.ChevronLeftIcon = require("./ChevronLeftIcon.js")
module.exports.ChevronRightIcon = require("./ChevronRightIcon.js")
module.exports.ChevronUpIcon = require("./ChevronUpIcon.js")
module.exports.ChipIcon = require("./ChipIcon.js")
module.exports.ClipboardCheckIcon = require("./ClipboardCheckIcon.js")
module.exports.ClipboardCopyIcon = require("./ClipboardCopyIcon.js")
module.exports.ClipboardListIcon = require("./ClipboardListIcon.js")
module.exports.ClipboardIcon = require("./ClipboardIcon.js")
module.exports.ClockIcon = require("./ClockIcon.js")
module.exports.CloudDownloadIcon = require("./CloudDownloadIcon.js")
module.exports.CloudUploadIcon = require("./CloudUploadIcon.js")
module.exports.CloudIcon = require("./CloudIcon.js")
module.exports.CodeIcon = require("./CodeIcon.js")
module.exports.CogIcon = require("./CogIcon.js")
module.exports.CollectionIcon = require("./CollectionIcon.js")
module.exports.ColorSwatchIcon = require("./ColorSwatchIcon.js")
module.exports.CreditCardIcon = require("./CreditCardIcon.js")
module.exports.CubeTransparentIcon = require("./CubeTransparentIcon.js")
module.exports.CubeIcon = require("./CubeIcon.js")
module.exports.CurrencyBangladeshiIcon = require("./CurrencyBangladeshiIcon.js")
module.exports.CurrencyDollarIcon = require("./CurrencyDollarIcon.js")
module.exports.CurrencyEuroIcon = require("./CurrencyEuroIcon.js")
module.exports.CurrencyPoundIcon = require("./CurrencyPoundIcon.js")
module.exports.CurrencyRupeeIcon = require("./CurrencyRupeeIcon.js")
module.exports.CurrencyYenIcon = require("./CurrencyYenIcon.js")
module.exports.CursorClickIcon = require("./CursorClickIcon.js")
module.exports.DatabaseIcon = require("./DatabaseIcon.js")
module.exports.DesktopComputerIcon = require("./DesktopComputerIcon.js")
module.exports.DeviceMobileIcon = require("./DeviceMobileIcon.js")
module.exports.DeviceTabletIcon = require("./DeviceTabletIcon.js")
module.exports.DocumentAddIcon = require("./DocumentAddIcon.js")
module.exports.DocumentDownloadIcon = require("./DocumentDownloadIcon.js")
module.exports.DocumentDuplicateIcon = require("./DocumentDuplicateIcon.js")
module.exports.DocumentRemoveIcon = require("./DocumentRemoveIcon.js")
module.exports.DocumentReportIcon = require("./DocumentReportIcon.js")
module.exports.DocumentSearchIcon = require("./DocumentSearchIcon.js")
module.exports.DocumentTextIcon = require("./DocumentTextIcon.js")
module.exports.DocumentIcon = require("./DocumentIcon.js")
module.exports.DotsCircleHorizontalIcon = require("./DotsCircleHorizontalIcon.js")
module.exports.DotsHorizontalIcon = require("./DotsHorizontalIcon.js")
module.exports.DotsVerticalIcon = require("./DotsVerticalIcon.js")
module.exports.DownloadIcon = require("./DownloadIcon.js")
module.exports.DuplicateIcon = require("./DuplicateIcon.js")
module.exports.EmojiHappyIcon = require("./EmojiHappyIcon.js")
module.exports.EmojiSadIcon = require("./EmojiSadIcon.js")
module.exports.ExclamationCircleIcon = require("./ExclamationCircleIcon.js")
module.exports.ExclamationIcon = require("./ExclamationIcon.js")
module.exports.ExternalLinkIcon = require("./ExternalLinkIcon.js")
module.exports.EyeOffIcon = require("./EyeOffIcon.js")
module.exports.EyeIcon = require("./EyeIcon.js")
module.exports.FastForwardIcon = require("./FastForwardIcon.js")
module.exports.FilmIcon = require("./FilmIcon.js")
module.exports.FilterIcon = require("./FilterIcon.js")
module.exports.FingerPrintIcon = require("./FingerPrintIcon.js")
module.exports.FireIcon = require("./FireIcon.js")
module.exports.FlagIcon = require("./FlagIcon.js")
module.exports.FolderAddIcon = require("./FolderAddIcon.js")
module.exports.FolderDownloadIcon = require("./FolderDownloadIcon.js")
module.exports.FolderOpenIcon = require("./FolderOpenIcon.js")
module.exports.FolderRemoveIcon = require("./FolderRemoveIcon.js")
module.exports.FolderIcon = require("./FolderIcon.js")
module.exports.GiftIcon = require("./GiftIcon.js")
module.exports.GlobeAltIcon = require("./GlobeAltIcon.js")
module.exports.GlobeIcon = require("./GlobeIcon.js")
module.exports.HandIcon = require("./HandIcon.js")
module.exports.HashtagIcon = require("./HashtagIcon.js")
module.exports.HeartIcon = require("./HeartIcon.js")
module.exports.HomeIcon = require("./HomeIcon.js")
module.exports.IdentificationIcon = require("./IdentificationIcon.js")
module.exports.InboxInIcon = require("./InboxInIcon.js")
module.exports.InboxIcon = require("./InboxIcon.js")
module.exports.InformationCircleIcon = require("./InformationCircleIcon.js")
module.exports.KeyIcon = require("./KeyIcon.js")
module.exports.LibraryIcon = require("./LibraryIcon.js")
module.exports.LightBulbIcon = require("./LightBulbIcon.js")
module.exports.LightningBoltIcon = require("./LightningBoltIcon.js")
module.exports.LinkIcon = require("./LinkIcon.js")
module.exports.LocationMarkerIcon = require("./LocationMarkerIcon.js")
module.exports.LockClosedIcon = require("./LockClosedIcon.js")
module.exports.LockOpenIcon = require("./LockOpenIcon.js")
module.exports.LoginIcon = require("./LoginIcon.js")
module.exports.LogoutIcon = require("./LogoutIcon.js")
module.exports.MailOpenIcon = require("./MailOpenIcon.js")
module.exports.MailIcon = require("./MailIcon.js")
module.exports.MapIcon = require("./MapIcon.js")
module.exports.MenuAlt1Icon = require("./MenuAlt1Icon.js")
module.exports.MenuAlt2Icon = require("./MenuAlt2Icon.js")
module.exports.MenuAlt3Icon = require("./MenuAlt3Icon.js")
module.exports.MenuAlt4Icon = require("./MenuAlt4Icon.js")
module.exports.MenuIcon = require("./MenuIcon.js")
module.exports.MicrophoneIcon = require("./MicrophoneIcon.js")
module.exports.MinusCircleIcon = require("./MinusCircleIcon.js")
module.exports.MinusSmIcon = require("./MinusSmIcon.js")
module.exports.MinusIcon = require("./MinusIcon.js")
module.exports.MoonIcon = require("./MoonIcon.js")
module.exports.MusicNoteIcon = require("./MusicNoteIcon.js")
module.exports.NewspaperIcon = require("./NewspaperIcon.js")
module.exports.OfficeBuildingIcon = require("./OfficeBuildingIcon.js")
module.exports.PaperAirplaneIcon = require("./PaperAirplaneIcon.js")
module.exports.PaperClipIcon = require("./PaperClipIcon.js")
module.exports.PauseIcon = require("./PauseIcon.js")
module.exports.PencilAltIcon = require("./PencilAltIcon.js")
module.exports.PencilIcon = require("./PencilIcon.js")
module.exports.PhoneIncomingIcon = require("./PhoneIncomingIcon.js")
module.exports.PhoneMissedCallIcon = require("./PhoneMissedCallIcon.js")
module.exports.PhoneOutgoingIcon = require("./PhoneOutgoingIcon.js")
module.exports.PhoneIcon = require("./PhoneIcon.js")
module.exports.PhotographIcon = require("./PhotographIcon.js")
module.exports.PlayIcon = require("./PlayIcon.js")
module.exports.PlusCircleIcon = require("./PlusCircleIcon.js")
module.exports.PlusSmIcon = require("./PlusSmIcon.js")
module.exports.PlusIcon = require("./PlusIcon.js")
module.exports.PresentationChartBarIcon = require("./PresentationChartBarIcon.js")
module.exports.PresentationChartLineIcon = require("./PresentationChartLineIcon.js")
module.exports.PrinterIcon = require("./PrinterIcon.js")
module.exports.PuzzleIcon = require("./PuzzleIcon.js")
module.exports.QrcodeIcon = require("./QrcodeIcon.js")
module.exports.QuestionMarkCircleIcon = require("./QuestionMarkCircleIcon.js")
module.exports.ReceiptRefundIcon = require("./ReceiptRefundIcon.js")
module.exports.ReceiptTaxIcon = require("./ReceiptTaxIcon.js")
module.exports.RefreshIcon = require("./RefreshIcon.js")
module.exports.ReplyIcon = require("./ReplyIcon.js")
module.exports.RewindIcon = require("./RewindIcon.js")
module.exports.RssIcon = require("./RssIcon.js")
module.exports.SaveAsIcon = require("./SaveAsIcon.js")
module.exports.SaveIcon = require("./SaveIcon.js")
module.exports.ScaleIcon = require("./ScaleIcon.js")
module.exports.ScissorsIcon = require("./ScissorsIcon.js")
module.exports.SearchCircleIcon = require("./SearchCircleIcon.js")
module.exports.SearchIcon = require("./SearchIcon.js")
module.exports.SelectorIcon = require("./SelectorIcon.js")
module.exports.ServerIcon = require("./ServerIcon.js")
module.exports.ShareIcon = require("./ShareIcon.js")
module.exports.ShieldCheckIcon = require("./ShieldCheckIcon.js")
module.exports.ShieldExclamationIcon = require("./ShieldExclamationIcon.js")
module.exports.ShoppingBagIcon = require("./ShoppingBagIcon.js")
module.exports.ShoppingCartIcon = require("./ShoppingCartIcon.js")
module.exports.SortAscendingIcon = require("./SortAscendingIcon.js")
module.exports.SortDescendingIcon = require("./SortDescendingIcon.js")
module.exports.SparklesIcon = require("./SparklesIcon.js")
module.exports.SpeakerphoneIcon = require("./SpeakerphoneIcon.js")
module.exports.StarIcon = require("./StarIcon.js")
module.exports.StatusOfflineIcon = require("./StatusOfflineIcon.js")
module.exports.StatusOnlineIcon = require("./StatusOnlineIcon.js")
module.exports.StopIcon = require("./StopIcon.js")
module.exports.SunIcon = require("./SunIcon.js")
module.exports.SupportIcon = require("./SupportIcon.js")
module.exports.SwitchHorizontalIcon = require("./SwitchHorizontalIcon.js")
module.exports.SwitchVerticalIcon = require("./SwitchVerticalIcon.js")
module.exports.TableIcon = require("./TableIcon.js")
module.exports.TagIcon = require("./TagIcon.js")
module.exports.TemplateIcon = require("./TemplateIcon.js")
module.exports.TerminalIcon = require("./TerminalIcon.js")
module.exports.ThumbDownIcon = require("./ThumbDownIcon.js")
module.exports.ThumbUpIcon = require("./ThumbUpIcon.js")
module.exports.TicketIcon = require("./TicketIcon.js")
module.exports.TranslateIcon = require("./TranslateIcon.js")
module.exports.TrashIcon = require("./TrashIcon.js")
module.exports.TrendingDownIcon = require("./TrendingDownIcon.js")
module.exports.TrendingUpIcon = require("./TrendingUpIcon.js")
module.exports.TruckIcon = require("./TruckIcon.js")
module.exports.UploadIcon = require("./UploadIcon.js")
module.exports.UserAddIcon = require("./UserAddIcon.js")
module.exports.UserCircleIcon = require("./UserCircleIcon.js")
module.exports.UserGroupIcon = require("./UserGroupIcon.js")
module.exports.UserRemoveIcon = require("./UserRemoveIcon.js")
module.exports.UserIcon = require("./UserIcon.js")
module.exports.UsersIcon = require("./UsersIcon.js")
module.exports.VariableIcon = require("./VariableIcon.js")
module.exports.VideoCameraIcon = require("./VideoCameraIcon.js")
module.exports.ViewBoardsIcon = require("./ViewBoardsIcon.js")
module.exports.ViewGridAddIcon = require("./ViewGridAddIcon.js")
module.exports.ViewGridIcon = require("./ViewGridIcon.js")
module.exports.ViewListIcon = require("./ViewListIcon.js")
module.exports.VolumeOffIcon = require("./VolumeOffIcon.js")
module.exports.VolumeUpIcon = require("./VolumeUpIcon.js")
module.exports.WifiIcon = require("./WifiIcon.js")
module.exports.XCircleIcon = require("./XCircleIcon.js")
module.exports.XIcon = require("./XIcon.js")
module.exports.ZoomInIcon = require("./ZoomInIcon.js")
module.exports.ZoomOutIcon = require("./ZoomOutIcon.js")


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/index.js
 ** module id = 82
 ** module chunks = 0
 **/